/** Trava de rolagem do documento, por contador.
 *
 *  Duas armadilhas já pagas no leitor-jwpub estão codificadas aqui.
 *
 *  A primeira: a trava é **por contador**, nunca "guardo o que havia".
 *  Guardar o valor anterior parece mais educado, mas duas folhas abertas ao
 *  mesmo tempo — uma confirmação por cima de um formulário — fazem a segunda
 *  guardar `hidden` como "o que havia" e devolver `hidden` ao fechar: a
 *  página fica travada para sempre. Com contador, quem fecha por último é
 *  quem solta, e a ordem em que fecham não importa.
 *
 *  A segunda: a trava vai no `documentElement`, **nunca no `body`**. No
 *  WebKit, um `position: fixed` sob ancestral com `overflow ≠ visible` se
 *  desgarra do viewport — e a folha é justamente um `fixed` que precisa
 *  cobrir a tela inteira. */
let travas = 0;

export function travarRolagem(): () => void {
  travas += 1;
  if (travas === 1) document.documentElement.style.overflow = 'hidden';
  // `soltou` é por chamada, não por módulo: é o que faz a devolução ser
  // idempotente. Sem ele, um `useEffect` que roda a limpeza duas vezes
  // (Modo Estrito, remontagem) derrubaria a trava de outra folha.
  let soltou = false;
  return () => {
    if (soltou) return;
    soltou = true;
    travas -= 1;
    if (travas === 0) document.documentElement.style.removeProperty('overflow');
  };
}
